import React from 'react'
import { usePageConfigUser } from 'hooks/usePageConfig'
import { WidgetId } from 'features/types'
import { DocumentRetrievalResult } from 'schemas/DocumentRetrievalResultSchema'
import { DashboardWidgetData } from 'features/widget/types'
import { createStreamWidgetDataFromDocumentRetrieval } from './createStreamWidgetDataFromDocumentRetrieval'
import SoundbiteStream from './SoundbiteStream'

type DocumentSoundbiteStreamFactoryProps = {
  widgetId: WidgetId
  widgetData: DashboardWidgetData<DocumentRetrievalResult>
  batch: number
}

const DocumentSoundbiteStreamFactory = React.memo(
  ({ widgetId, widgetData, batch }: DocumentSoundbiteStreamFactoryProps): React.ReactElement => {
    const { timeZone } = usePageConfigUser()

    const documentRetrievalResult = widgetData.results![0]!.data
    const {
      soundbites,
      deletedSentenceCount,
      deletedSentenceDateRangeFrom,
      deletedSentenceDateRangeTo
    } = createStreamWidgetDataFromDocumentRetrieval(documentRetrievalResult, timeZone)

    const unDeletedSoundbites = soundbites.filter((soundbite) => !soundbite.deleted)

    return (
      <SoundbiteStream
        widgetId={widgetId}
        soundbites={unDeletedSoundbites}
        deletedSentenceCount={deletedSentenceCount}
        deletedSentenceDateRangeFrom={deletedSentenceDateRangeFrom!}
        deletedSentenceDateRangeTo={deletedSentenceDateRangeTo!}
        batch={batch}
      />
    )
  }
)

export default DocumentSoundbiteStreamFactory
